import DivComponent from "../components/div";
import ImgComponent from "../components/img";
import {isEmptyArray} from "../utils/is-empty-array";
import {RenderPosition, render} from "../utils/render";

export default class ImagesHvrController {
  constructor({images = [], title = ``}) {
    this._images = images;
    this._title = title;

    this._imageComponents = [];
    this._dotComponents = [];
  }

  render(container) {
    if (isEmptyArray(this._images)) {
      return;
    }

    const hvrWrap = new DivComponent(`hvr`);
    render(container, hvrWrap.getElement(), RenderPosition.BEFOREEND);

    // отрисовка картинок
    const hvrImagesWrap = new DivComponent(`hvr__images`);
    render(hvrWrap.getElement(), hvrImagesWrap.getElement(), RenderPosition.BEFOREEND);

    const imagesWrap = new DivComponent(`images`);
    render(hvrImagesWrap.getElement(), imagesWrap.getElement(), RenderPosition.BEFOREEND);

    const hvrSectorsWrap = new DivComponent(`hvr__sectors`);
    render(hvrImagesWrap.getElement(), hvrSectorsWrap.getElement(), RenderPosition.BEFOREEND);

    // отрисовка точек
    const hvrDotsWrap = new DivComponent(`hvr__dots`);
    render(hvrWrap.getElement(), hvrDotsWrap.getElement(), RenderPosition.BEFOREEND);

    this._images.forEach((image, i) => {
      const imageComponent = new ImgComponent({
        source: image,
        title: this._title,
      });

      imageComponent.getElement().style.display = (!i) ? `block` : `none`;

      render(imagesWrap.getElement(), imageComponent.getElement(), RenderPosition.BEFOREEND);
      this._imageComponents.push(imageComponent.getElement());


      const hvrSector = new DivComponent(`hvr__sector`);
      render(hvrSectorsWrap.getElement(), hvrSector.getElement(), RenderPosition.BEFOREEND);


      const hvrDot = new DivComponent(`hvr__dot`);
      render(hvrDotsWrap.getElement(), hvrDot.getElement(), RenderPosition.BEFOREEND);
      this._dotComponents.push(hvrDot.getElement());

      if (!i) {
        hvrDot.getElement().classList.add(`hvr__dot--active`);
      }
    });


    hvrSectorsWrap.getElement().addEventListener(`mouseover`, (evt) => {
      if (evt.target.classList.contains(`hvr__sector`)) {
        const index = [...hvrSectorsWrap.getElement().children].indexOf(evt.target);
        this._setActive(index);
      }
    });

    hvrSectorsWrap.getElement().addEventListener(`mouseout`, (evt) => {
      if (!evt.relatedTarget) {
        return;
      }
      if (!evt.relatedTarget.classList.contains(`hvr__sector`)) {
        this._setActive(0);
      }
    });
  }

  _setActive(index) {
    this._imageComponents.forEach((img, i) => {
      img.style.display = (index === i) ? `block` : `none`;
    });

    this._dotComponents.forEach((dot, i) => {
      if (index === i) {
        dot.classList.add(`hvr__dot--active`);
      } else {
        dot.classList.remove(`hvr__dot--active`);
      }
    });
  }
}
